import { render } from "./SetupRecurringServices.vue?vue&type=template&id=c72f4850&scoped=true"
import script from "./SetupRecurringServices.vue?vue&type=script&lang=js"
export * from "./SetupRecurringServices.vue?vue&type=script&lang=js"

import "./SetupRecurringServices.vue?vue&type=style&index=0&id=c72f4850&scoped=true&lang=css"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c72f4850"]])

export default __exports__